const MIN_MATCHUP_SCORE_GOOD = 3

export const getOverallGrade = (overallScore: number) => {
  // assign grades 'A' -> GREAT, 'B' -> GOOD, 'C' -> POOR,  to matchups for sorting purpose
  if (overallScore > MIN_MATCHUP_SCORE_GOOD) return 'A'
  if (overallScore < MIN_MATCHUP_SCORE_GOOD) return 'C'
  return 'B'
}
